import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// vehicle_image_types — ประเภทรูปภาพ/วิดีโอ รถ (configurable master data)
// ============================================================================
export const vehicleImageTypes = sqliteTable("fleet_vehicle_image_types", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  name: text("name").notNull(), // Thai name: "ภายนอก"
  nameEn: text("name_en"), // English: "Exterior"
  mediaType: text("media_type").notNull().default("image"), // "image" | "video"
  isPublic: integer("is_public").notNull().default(0), // visible to customers?
  isActive: integer("is_active").notNull().default(1),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type VehicleImageType = typeof vehicleImageTypes.$inferSelect;
export type NewVehicleImageType = typeof vehicleImageTypes.$inferInsert;
